(function () {
  var selector = '.cudli-reviews';

  function init(root) {
    if (!root || root.dataset.smoothCarouselReady === 'true') return;
    var viewport = root.querySelector('[data-review-carousel]');
    var track = viewport && viewport.querySelector('.cudli-review-grid');
    if (!viewport || !track) return;

    root.dataset.smoothCarouselReady = 'true';
    var originals = Array.prototype.slice.call(track.children);
    if (originals.length < 2) return;
    var isMobile = window.matchMedia('(max-width: 800px)').matches;

    originals.forEach(function (card) { card.dataset.reviewOriginal = 'true'; });

    var before = document.createDocumentFragment();
    var after = document.createDocumentFragment();
    originals.forEach(function (card) {
      var a = card.cloneNode(true);
      var b = card.cloneNode(true);
      a.setAttribute('aria-hidden', 'true');
      b.setAttribute('aria-hidden', 'true');
      before.appendChild(a);
      after.appendChild(b);
    });
    track.insertBefore(before, track.firstChild);
    track.appendChild(after);

    if (isMobile) {
      viewport.classList.add('is-mobile-continuous');
      viewport.style.overflowX = 'auto';
      viewport.style.overflowY = 'hidden';
      viewport.style.touchAction = 'pan-x pan-y';
      viewport.style.overscrollBehaviorX = 'contain';
      viewport.style.scrollSnapType = 'none';
    }

    var originalStart = 0;
    var afterStart = 0;
    var loopWidth = 0;
    function measure(reset) {
      var firstOriginal = track.querySelector('[data-review-original="true"]');
      var firstAfter = track.children[originals.length * 2];
      if (!firstOriginal || !firstAfter) return;
      originalStart = firstOriginal.offsetLeft - track.offsetLeft;
      afterStart = firstAfter.offsetLeft - track.offsetLeft;
      loopWidth = afterStart - originalStart;
      if (reset || viewport.scrollLeft < loopWidth * 0.5 || viewport.scrollLeft > loopWidth * 2.5) {
        viewport.scrollLeft = originalStart;
      }
    }

    requestAnimationFrame(function () { measure(true); });
    window.addEventListener('resize', function () { measure(false); }, { passive: true });

    var dragging = false;
    var touching = false;
    var paused = false;
    var resumeTimer = 0;
    var startX = 0;
    var startScroll = 0;
    var lastTime = 0;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function normalize() {
      if (!loopWidth || touching || dragging) return;
      if (viewport.scrollLeft >= afterStart) viewport.scrollLeft -= loopWidth;
      if (viewport.scrollLeft < originalStart - loopWidth) viewport.scrollLeft += loopWidth;
    }

    function temporarilyPause(delay) {
      paused = true;
      window.clearTimeout(resumeTimer);
      resumeTimer = window.setTimeout(function () {
        normalize();
        paused = false;
      }, delay || 2200);
    }

    function animate(time) {
      if (!lastTime) lastTime = time;
      var delta = Math.min(time - lastTime, 40);
      lastTime = time;
      if (!paused && !dragging && !touching && !reduceMotion && loopWidth) {
        viewport.scrollLeft += delta * 0.018;
        normalize();
      }
      requestAnimationFrame(animate);
    }
    requestAnimationFrame(animate);

    viewport.addEventListener('mouseenter', function () { if (!isMobile) paused = true; });
    viewport.addEventListener('mouseleave', function () { if (!isMobile && !dragging) temporarilyPause(700); });
    viewport.addEventListener('focusin', function () { paused = true; });
    viewport.addEventListener('focusout', function () { temporarilyPause(700); });

    if (isMobile) {
      var manualScrolling = false;

      function scheduleMobileResume() {
        window.clearTimeout(resumeTimer);
        resumeTimer = window.setTimeout(function () {
          if (touching) return;
          normalize();
          manualScrolling = false;
          paused = false;
        }, 2500);
      }

      viewport.addEventListener('touchstart', function () {
        touching = true;
        manualScrolling = true;
        paused = true;
        window.clearTimeout(resumeTimer);
      }, { passive: true });

      viewport.addEventListener('touchend', function () {
        touching = false;
        scheduleMobileResume();
      }, { passive: true });

      viewport.addEventListener('touchcancel', function () {
        touching = false;
        scheduleMobileResume();
      }, { passive: true });

      viewport.addEventListener('scroll', function () {
        if (manualScrolling) scheduleMobileResume();
      }, { passive: true });
    } else {
      viewport.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        dragging = true;
        paused = true;
        startX = event.clientX;
        startScroll = viewport.scrollLeft;
        viewport.classList.add('is-dragging');
        viewport.setPointerCapture(event.pointerId);
      });
      viewport.addEventListener('pointermove', function (event) {
        if (!dragging) return;
        viewport.scrollLeft = startScroll - (event.clientX - startX);
      });
      function stop(event) {
        if (!dragging) return;
        dragging = false;
        viewport.classList.remove('is-dragging');
        try { viewport.releasePointerCapture(event.pointerId); } catch (error) {}
        temporarilyPause(1800);
      }
      viewport.addEventListener('pointerup', stop);
      viewport.addEventListener('pointercancel', stop);
    }

    viewport.querySelectorAll('img').forEach(function (img) { img.draggable = false; });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll(selector).forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();